import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/menu.scss'
import permissionDirective from './directives/permission'

Vue.use(ElementUI)
Vue.use(permissionDirective)

Vue.config.productionTip = false

// 先挂载再刷新权限，避免 await 接口期间整页白屏
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (store.state.token) {
  store.dispatch('getUserInfo')
}
